export default function currencyMillionFormat(value: number | any) {
    value = value / 1000000;
    return new Intl.NumberFormat('id-ID', {style: 'currency', currency: 'IDR', minimumFractionDigits: 0, maximumFractionDigits: 2}).format(value) + 'jt';
}
